import zhCN from "./zh-CN.js";
import enUS from "./en-US.js";
import jaJP from "./ja-JP.js";
import koKR from "./ko-KR.js";
// import esES from './es-ES.js'
export default {
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
    "ja-JP": jaJP,
    "ko-KR": koKR
    // 'es-ES': esES
  }
};
